import { Chip } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ChipEnabled = styled(Chip)<{ enabled: string | undefined }>`
  color: white;
  background-color: ${(props) =>
    props.enabled === 'true' ? 'green' : '#f44336'};
`;
